import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, uniq } from 'lodash';
import { round } from 'mathjs';

import Color from '@tool/color';
import moIndex from '../../store/index';
import { newValue, newRate } from '@tool/index';

const moLeaveRate = observable({
  xData: <any[]>[],
  yData: <any[]>[],
  tableLeft: <any[]>[],
  tableRight: <any[]>[],
  tableHead: <any[]>[],
  overview: <any[]>[],
  labels: <any[]>[],
});

// 行业离职率 初始化
const initIndustryLeaveRate = action((result: any) => {
  // console.log('行业离职率 -- ', result);
  if (isEmpty(result)) return;

  let xData: any[] = [];
  const yData: any[] = [];
  const tableLeft: any[] = [];
  const tableRight: any[] = [];
  let years: any[] = [];
  const labels: any[] = [];
  const overview: any[] = [];
  const tempX: any[] = [];
  const tempYear: any[] = [];
  const tempOverview: any[] = [];
  const res: any[] = [];

  result.map((item: any) => {
    if (item.industry_lv1 !== '全行业') res.push(item);
  });

  res.map((item: any) => {
    tempX.push(item.industry_lv2 || item.industry_lv1);
    tempYear.push(item.year);
    tableLeft.push(item.industry_lv2 || item.industry_lv1);
  });
  xData = uniq(tempX);
  years = uniq(tempYear);

  years.map((year: any) => {
    const tempArr: any[] = [];
    xData.map((industryName: string) => {
      res.map((item: any) => {
        if (
          item.year === year && (item.industry_lv2 === industryName || item.industry_lv1 === industryName)
        ) {
          tempArr.push(item.rate);
        }
      });
    });
    yData.push({
      name: year,
      data: tempArr,
    });
  });

  // console.log('years -- ', years);
  // console.log('xData -- ', xData);
  // console.log('yData -- ', yData);

  result.map((item: any) => {
    if (item.industry_lv1 === '全行业') {
      labels.push({
        value: item.rate,
        year: item.year,
      });
    }
  });

  yData.map((item: any) => {
    let maxValue = 0;
    item.data.map((val: any) => {
      if (val > maxValue) maxValue = val;
    });
    tempOverview.push({
      year: item.name,
      maxValue: maxValue,
      industryName: '',
    });
  });

  tempOverview.map((item: any) => {
    res.map((child: any) => {
      if (item.year === child.year && item.maxValue === child.rate) {
        item.industryName = child.industry_lv2 || child.industry_lv1;
      }
    });
  });
  tempOverview.map((item: any) => {
    overview.push(`${item.year}年，「${item.industryName}」离职率最高`);
  });

  // console.log('overview -- ', overview);
  // console.log('labels -- ', labels);

  xData.map((industryName: any) => {
    const tempList: any[] = [];
    years.map((year: any) => {
      res.map((item: any) => {
        if (
          (item.year === year && item.industry_lv2 === industryName) ||
          (item.year === year && item.industry_lv2 === '' && item.industry_lv1 === industryName)
        ) {
          tempList.push(item.rate);
        }
      });
    });
    tableRight.push(tempList);
  });
  // console.log('table right -- ', tableRight);

  moLeaveRate.xData = xData;
  moLeaveRate.yData = yData;
  moLeaveRate.overview = overview;
  moLeaveRate.tableLeft = uniq(tableLeft);
  moLeaveRate.tableRight = tableRight;
  moLeaveRate.tableHead = uniq(years);
  moLeaveRate.labels = labels;
});

export default moLeaveRate;
export { initIndustryLeaveRate };
